import useHandleMOCError from './use-handle-moc-error';

export default useHandleMOCError;
